export default "__VITE_ASSET__DjWqXx5f__"